// extracted by mini-css-extract-plugin
module.exports = {"text-input":"Input_text-input__qNadQ"};